import { ShopifyAppNames } from "@redotech/redo-order-common/sales-channels";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { enum as zEnum } from "zod";

export enum CloudXUPCType {
  SKU = "sku",
  BARCODE = "barcode",
}

export enum CloudXCancelASNOn {
  REJECT = "reject",
  RESET = "reset",
  BOTH = "both",
  NEVER = "never",
}

const CloudXIntegrationDataSchema_ = z.object({
  clientSecret: z.string().optional(),
  warehouseAsPlainString: z.string(),
  warehouseTimezone: z.string().optional(),
  testMode: z.boolean(),
  autoProcessReturns: z.boolean(),
  createReturns: z.boolean(),
  upcType: zEnum(CloudXUPCType),
  excludedAppNames: z.array(createEnum(ShopifyAppNames)),
  cancelASNOn: zEnum(CloudXCancelASNOn).optional(),
});

export const CloudXIntegrationDataSchema: z.ZodType<CloudXIntegrationData> =
  CloudXIntegrationDataSchema_;
export interface CloudXIntegrationData extends z.infer<
  typeof CloudXIntegrationDataSchema_
> {}
